package rendering

import editor.capture.CaptureManager
import ext.insertAsFirst
import kotlinx.browser.document
import kotlinx.browser.window
import three.js.WebGLRenderer
import three.js.WebGLRendererParameters

object RendererManager {
    fun render() {
        // todo fix position of stuff when exiting vr

        if (renderer.xr.isPresenting) {
            // fix m -> mm
            SceneManager.scene.scale.set(0.001, 0.001, 0.001)
        } else {
            SceneManager.scene.scale.set(1, 1, 1)
        }

        SceneManager.updateCameraLightPosition()
        CaptureManager.beforeRender()
        if (renderer.xr.isPresenting) {
            // Render without (outline) effects: renderer.render(SceneManager.scene, CameraManager.camera)
            renderer.render(SceneManager.scene, CameraManager.camera)
        }
        else {
            EffectManager.render()
        }
        CaptureManager.afterRender(renderer.domElement)
    }

    val renderer = WebGLRenderer(object : WebGLRendererParameters {
        override var alpha: Boolean? = true
        override var antialias: Boolean? = true
    }).apply {
        document.body!!.insertAsFirst(domElement)
        xr.enabled = true
        setSize(window.innerWidth, window.innerHeight)
        setPixelRatio(window.devicePixelRatio)
    }

    init {
        window.addEventListener("resize", {
            renderer.setSize(window.innerWidth, window.innerHeight)
        })
    }
}

